import { z } from 'zod';
import { CreatePersonInputDTOSchema, } from "../../../persons/index.js";
// Guarantor is a person — same input shape, address and birthDate are already nullable
export const CreateGuarantorInputDTOSchema = CreatePersonInputDTOSchema;
// Request schema for API validation
export const CreateGuarantorRequestDTOSchema = z.object({
    body: CreateGuarantorInputDTOSchema,
    params: z.object({
        companyId: z.uuid(),
        facilityId: z.uuid(),
        applicationId: z.uuid(),
    }),
});
//# sourceMappingURL=create-guarantor.dto.js.map